import { z } from 'zod';

export const searchInventorySchema = z.object({
  vin: z.string(),
  stockNumber: z.string(),
});
